/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Role_Bound_InvestorInputs */

const cs_clients_role_bound_investor = /** @type {(inputs: Clients_Role_Bound_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investorský profil: strategie, riziko, způsob financování, horizont, výnos a typ aktiv (ne financování poptávky).`)
};

const en_clients_role_bound_investor = /** @type {(inputs: Clients_Role_Bound_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor profile: strategy, risk, financing method, horizon, return & asset prefs (not demand financing).`)
};

/**
* | output |
* | --- |
* | "Investor profile: strategy, risk, financing method, horizon, return & asset prefs (not demand financing)." |
*
* @param {Clients_Role_Bound_InvestorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_role_bound_investor = /** @type {((inputs?: Clients_Role_Bound_InvestorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Role_Bound_InvestorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_role_bound_investor(inputs)
	return cs_clients_role_bound_investor(inputs)
});